import {
  UserProfileActionTypes,
  StsUser,
  StsAddress,
  SAVED_USER_CONTACTINFO,
  ERROR_SAVING_USER_CONTACTINFO,
  UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS,
  UPDATED_DEVICE_TRUST_PARTICIPATION_STATUS,
  ERROR_UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS,
} from './types';
import {
  UserProfileViewModel,
  UserContactViewModel,
} from '../../model/profile/types';
import { ApiError } from '../../api/types';

const initialState: UserProfileViewModel = {
  contact: null,
  devicetrust: null,
};

const reducer = (
  state = initialState,
  action: UserProfileActionTypes
): UserProfileViewModel => {
  switch (action.type) {
    case 'redux-oidc/USER_FOUND': {
      const { profile } = action.payload as StsUser;

      const address = JSON.parse(profile.address || '{}') as StsAddress;

      return {
        ...state,
        contact: {
          firstName: profile.given_name || '',
          lastName: profile.family_name || '',
          emailAddress: profile.email || '',
          middleName: profile.middle_name,
          department: profile.department || '',
          addressLines: (address.street_address || '').split(/\r?\n/),
          city: address.locality || '',
          state: address.region || '',
          country: address.country || '',
          zipCode: address.postal_code || '',
          phone: profile.phone_number || '',
          title: profile.title || '',
        },
        devicetrust: {
          isUpdating: false,
          canToggle: JSON.parse(
            (profile.devicetrustcantoggle || 'false').toLowerCase()
          ),
          isEnrolled: JSON.parse(
            (profile.devicetrustenabled || 'false').toLowerCase()
          ),
        },
      };
    }
    case SAVED_USER_CONTACTINFO: {
      return {
        ...state,
        contact: {
          ...(action.payload as UserContactViewModel),
          error: undefined,
        },
      };
    }
    case ERROR_SAVING_USER_CONTACTINFO: {
      return {
        ...state,
        contact: {
          ...(state.contact || {
            firstName: '',
            lastName: '',
            emailAddress: '',
            middleName: '',
            department: '',
            addressLines: ['', '', ''],
            city: '',
            state: '',
            country: '',
            zipCode: '',
            phone: '',
          }),
          error: action.payload as ApiError,
        },
      };
    }

    case UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS: {
      return {
        ...state,
        devicetrust: {
          ...(state.devicetrust || {
            canToggle: false,
            isEnrolled: false,
          }),
          isUpdating: true,
        },
      };
    }

    case UPDATED_DEVICE_TRUST_PARTICIPATION_STATUS: {
      return {
        ...state,
        devicetrust: {
          ...(state.devicetrust || {
            canToggle: false,
          }),
          isEnrolled: action.payload as boolean,
          isUpdating: false,
        },
      };
    }

    case ERROR_UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS: {
      return {
        ...state,
        devicetrust: {
          ...(state.devicetrust || {
            canToggle: false,
            isEnrolled: false,
          }),
          isUpdating: false,
          error: action.payload as ApiError,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
